import React from 'react';
import { default as Carousel } from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

const OwlCarousel = ({ children, ...rest }) => <Carousel {...rest}>{children}</Carousel>;

export default OwlCarousel;
